"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ModuleErrorFetch {
    constructor(error) {
        this.messages = error.messages || '';
        this.status = error.status || -1;
    }
    get getMessages() {
        return this.messages;
    }
    get getStatus() {
        return this.status;
    }
}
exports.default = ModuleErrorFetch;
